module.exports = "//static.hsappstatic.net/salesImages/static-1.403/integrations/applications-list-icon-placeholder.png"